<template>
  <div>
    <nav class="uk-navbar-container uk-navbar" uk-navbar>
      <div class="uk-navbar-left">
        <a class="uk-navbar-item uk-logo" href="https://ucari.com/">
          <img src="/images/logo.png" alt="UCARI Logo" width="100">
          <span v-if="isAuthenticated && isPro" class="pro-badge uk-margin-small-left">
            PRO
          </span>
        </a>
      </div>
      <div class="uk-navbar-right no-print header-nav-desktop">
        <ul class="uk-navbar-nav">

          <!-- Test Kits link -->
          <li v-if="isAuthenticated" :class="{ 'uk-active': isActive('/') }">
            <span v-if="isActive('/')" class="uk-navbar-item nav-current" aria-current="page">
              My Test Kits
            </span>
            <router-link v-else to="/" class="uk-navbar-item">
              My Test Kits
            </router-link>
          </li>

          <!-- Register Kit -->
          <li v-if="isAuthenticated" :class="{ 'uk-active': isActive('/register-kit') }">
            <span v-if="isActive('/register-kit')" class="uk-navbar-item nav-current" aria-current="page">
              Register Kit
            </span>
            <router-link v-else to="/register-kit" class="uk-navbar-item">
              Register Kit
            </router-link>
          </li>

          <li v-if="showIngredientCheckerNav" :class="{ 'uk-active': isActive('/ingredient-checker') }">
            <span v-if="isActive('/ingredient-checker')" class="uk-navbar-item nav-current" aria-current="page">
              Ingredient Checker
            </span>
            <router-link v-else to="/ingredient-checker" class="uk-navbar-item">
              Ingredient Checker
            </router-link>
          </li>

          <li v-if="isAuthenticated" :class="{ 'uk-active': isAddOnServiceActive }" class="services-nav-item">
            <button
              type="button"
              class="uk-navbar-item services-nav-trigger"
              aria-haspopup="true"
            >
              Add-on Services
              <span uk-icon="icon: chevron-down; ratio: 0.75" aria-hidden="true"></span>
            </button>
            <div uk-dropdown="mode: click; pos: bottom-left; offset: 4" class="services-menu">
              <p class="services-menu__eyebrow">Support beyond your results</p>
              <ul class="uk-nav uk-dropdown-nav services-menu__list">
                <li v-if="showIngredientCheckerSubscriptionNav" :class="{ 'uk-active': isActive('/ingredient-checker-subscription') }">
                  <span v-if="isActive('/ingredient-checker-subscription')" class="services-menu__item nav-current-dropdown" aria-current="page">
                    <span class="services-menu__icon" uk-icon="icon: camera"></span>
                    <span><strong>Unlimited Ingredient Checking</strong><small>Scan every label against your results</small></span>
                  </span>
                  <router-link v-else to="/ingredient-checker-subscription" class="services-menu__item">
                    <span class="services-menu__icon" uk-icon="icon: camera"></span>
                    <span><strong>Unlimited Ingredient Checking</strong><small>Scan every label against your results</small></span>
                  </router-link>
                </li>
                <li v-if="showNutrable" :class="{ 'uk-active': isActive('/12-week-nutrition-program') }">
                  <span v-if="isActive('/12-week-nutrition-program')" class="services-menu__item nav-current-dropdown" aria-current="page">
                    <span class="services-menu__icon" uk-icon="icon: heart"></span>
                    <span><strong>Nutrable Nutrition Coaching</strong><small>Build a 12-week plan around your results</small></span>
                  </span>
                  <router-link v-else to="/12-week-nutrition-program" class="services-menu__item">
                    <span class="services-menu__icon" uk-icon="icon: heart"></span>
                    <span><strong>Nutrable Nutrition Coaching</strong><small>Build a 12-week plan around your results</small></span>
                  </router-link>
                </li>
                <li :class="{ 'uk-active': isActive('/pet-vet-connection') }">
                  <span v-if="isActive('/pet-vet-connection')" class="services-menu__item nav-current-dropdown" aria-current="page">
                    <span class="services-menu__icon" uk-icon="icon: comments"></span>
                    <span><strong>PetVet</strong><small>Text or video guidance from veterinarians</small></span>
                  </span>
                  <router-link v-else to="/pet-vet-connection" class="services-menu__item">
                    <span class="services-menu__icon" uk-icon="icon: comments"></span>
                    <span><strong>PetVet</strong><small>Text or video guidance from veterinarians</small></span>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>

          <li v-if="isAuthenticated" class="uk-margin-small-left">
            <a href="#" class="uk-flex uk-flex-middle" @click.prevent>
              <span uk-icon="icon: user"></span>
            </a>
            <div uk-dropdown="mode: click; pos: bottom-right" class="uk-padding-small">
              <ul class="uk-nav uk-dropdown-nav">
                <li :class="{ 'uk-active': isActive('/profile') }">
                  <span v-if="isActive('/profile')" class="uk-flex uk-flex-middle nav-current-dropdown" aria-current="page">
                    <span uk-icon="icon: user" class="uk-margin-small-right"></span>
                    Profile
                  </span>
                  <router-link v-else to="/profile" class="uk-flex uk-flex-middle">
                    <span uk-icon="icon: user" class="uk-margin-small-right"></span>
                    Profile
                  </router-link>
                </li>
                <li :class="{ 'uk-active': isActive('/ingredient-checker-history') }">
                  <span v-if="isActive('/ingredient-checker-history')" class="uk-flex uk-flex-middle nav-current-dropdown" aria-current="page">
                    <span uk-icon="icon: history" class="uk-margin-small-right"></span>
                    Ingredient Checker History
                  </span>
                  <router-link v-else to="/ingredient-checker-history" class="uk-flex uk-flex-middle">
                    <span uk-icon="icon: history" class="uk-margin-small-right"></span>
                    Ingredient Checker History
                  </router-link>
                </li>
                <li>
                  <a href="#" class="uk-flex uk-flex-middle" @click.prevent="logout">
                    <span uk-icon="icon: sign-out" class="uk-margin-small-right"></span>
                    Logout
                  </a>
                </li>

              </ul>
            </div>
          </li>

        </ul>
      </div>
      <div v-if="isAuthenticated" class="uk-navbar-right no-print header-nav-mobile">
        <div class="uk-flex uk-flex-middle mobile-header-actions">
          <div class="mobile-profile-trigger">
            <a href="#" class="uk-flex uk-flex-middle mobile-profile-button" @click.prevent>
              <span uk-icon="icon: user"></span>
            </a>
            <div uk-dropdown="mode: click; pos: bottom-right" class="uk-padding-small">
              <ul class="uk-nav uk-dropdown-nav">
                <li :class="{ 'uk-active': isActive('/profile') }">
                  <span v-if="isActive('/profile')" class="uk-flex uk-flex-middle nav-current-dropdown" aria-current="page">
                    <span uk-icon="icon: user" class="uk-margin-small-right"></span>
                    Profile
                  </span>
                  <router-link v-else to="/profile" class="uk-flex uk-flex-middle">
                    <span uk-icon="icon: user" class="uk-margin-small-right"></span>
                    Profile
                  </router-link>
                </li>
                <li>
                  <a href="#" class="uk-flex uk-flex-middle" @click.prevent="logout">
                    <span uk-icon="icon: sign-out" class="uk-margin-small-right"></span>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <a
            href="#mobile-nav"
            class="uk-navbar-toggle mobile-menu-toggle"
            uk-toggle
            aria-label="Open navigation menu"
          >
            <span uk-navbar-toggle-icon></span>
          </a>
        </div>
      </div>
    </nav>

    <div id="mobile-nav" uk-offcanvas="mode: slide; overlay: true; flip: true">
      <div class="uk-offcanvas-bar uk-offcanvas-bar-light mobile-nav-drawer">
        <button class="uk-offcanvas-close" type="button" uk-close aria-label="Close navigation menu"></button>

        <ul class="uk-nav uk-nav-default mobile-nav-links">
          <li v-if="isAuthenticated" :class="{ 'uk-active': isActive('/') }">
            <router-link to="/" @click="closeMobileMenu">My Test Kits</router-link>
          </li>
          <li v-if="isAuthenticated" :class="{ 'uk-active': isActive('/register-kit') }">
            <router-link to="/register-kit" @click="closeMobileMenu">Register Kit</router-link>
          </li>
          <li v-if="showIngredientCheckerNav" :class="{ 'uk-active': isActive('/ingredient-checker') }">
            <router-link to="/ingredient-checker" @click="closeMobileMenu">Ingredient Checker</router-link>
          </li>
          <li v-if="isAuthenticated" class="mobile-services-group" :class="{ 'mobile-services-group--active': isAddOnServiceActive }">
            <details :open="isAddOnServiceActive">
              <summary>
                <span>Add-on Services</span>
                <span uk-icon="icon: chevron-down; ratio: 0.8" aria-hidden="true"></span>
              </summary>
              <ul>
                <li v-if="showIngredientCheckerSubscriptionNav" :class="{ 'uk-active': isActive('/ingredient-checker-subscription') }">
                  <router-link to="/ingredient-checker-subscription" @click="closeMobileMenu">
                    <strong>Unlimited Ingredient Checking</strong>
                    <small>Compare every label with your results</small>
                  </router-link>
                </li>
                <li v-if="showNutrable" :class="{ 'uk-active': isActive('/12-week-nutrition-program') }">
                  <router-link to="/12-week-nutrition-program" @click="closeMobileMenu">
                    <strong>Nutrable Nutrition Coaching</strong>
                    <small>Build a 12-week plan around your results</small>
                  </router-link>
                </li>
                <li :class="{ 'uk-active': isActive('/pet-vet-connection') }">
                  <router-link to="/pet-vet-connection" @click="closeMobileMenu">
                    <strong>PetVet</strong>
                    <small>Veterinary guidance by text or video</small>
                  </router-link>
                </li>
              </ul>
            </details>
          </li>
          <li :class="{ 'uk-active': isActive('/ingredient-checker-history') }">
            <router-link to="/ingredient-checker-history" @click="closeMobileMenu">Ingredient Checker History</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { canAccessNutrable } from '@/utils/nutrable';
import axios from 'axios';
import { isIngredientCheckerEnabledForCid, shouldHideIngredientChecker } from '@/utils/common';

export default {
  data() {
    return {
      isAuthenticated: false,
      firstName: '',
      cid: '',
      accessToken: '',
      isPro: false,
      showNutrable: false,
    };
  },
  created() {
    this.loadCredentials();
    this.checkAuthentication();
  },
  computed: {
    showIngredientCheckerNav() {
      return this.isAuthenticated && !shouldHideIngredientChecker(this.cid);
    },
    showIngredientCheckerSubscriptionNav() {
      return this.isAuthenticated && isIngredientCheckerEnabledForCid(this.cid);
    },
    isAddOnServiceActive() {
      return [
        '/ingredient-checker-subscription',
        '/12-week-nutrition-program',
        '/pet-vet-connection'
      ].includes(this.$route.path);
    }
  },
  methods: {
    loadCredentials() {
      this.accessToken = localStorage.getItem('accessToken');
      this.cid = localStorage.getItem('cid');
      const isProValue = localStorage.getItem('isPro');
      this.isPro = isProValue === '1' || isProValue === 'true';
    },
    async checkAuthentication() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/api/check-auth`, {
          headers: {
            'Authorization': `Bearer ${this.accessToken}`,
            'cid': this.cid,
            'isPro': this.isPro
          }
        });
        this.isAuthenticated = response.data.authenticated;
        this.showNutrable = this.isAuthenticated && await canAccessNutrable();
      } catch (err) {
        console.error('Session check failed', err);
        this.isAuthenticated = false;
        this.showNutrable = false;
      }
    },
    async logout() {
      try {
        await axios.post(`${process.env.VUE_APP_API_URL}/api/logout`);
        localStorage.removeItem('accessToken');
        localStorage.removeItem('cid');
        localStorage.removeItem('isPro');
        this.isAuthenticated = false;
        this.showNutrable = false;
        this.$router.push('/login');
      } catch (err) {
        console.error('Logout failed', err);
      }
    },
    isActive(path) {
      return this.$route.path === path;
    },
    closeMobileMenu() {
      const offcanvasEl = document.getElementById('mobile-nav');
      if (offcanvasEl && window.UIkit?.offcanvas) {
        window.UIkit.offcanvas(offcanvasEl).hide();
      }
    }
  }
};
</script>

<style scoped>
.header-nav-mobile {
  display: none;
}

.mobile-header-actions {
  gap: 6px;
}

.uk-navbar-container .uk-navbar-nav > li > a,
.uk-navbar-container .uk-navbar-item,
.uk-navbar-container .uk-navbar-toggle {
  min-height: 48px;
}

.header-nav-desktop .uk-navbar-nav > li > .uk-navbar-item,
.header-nav-desktop .uk-navbar-nav > li > a {
  color: #07468d !important;
  font-weight: 400;
}

.header-nav-desktop .uk-navbar-nav > li.uk-active > .uk-navbar-item,
.header-nav-desktop .uk-navbar-nav > li.uk-active > .services-nav-trigger {
  background: transparent;
  box-shadow: inset 0 -3px #f05798;
  font-weight: 400;
}

.header-nav-desktop .uk-navbar-nav > li > a:hover,
.header-nav-desktop .uk-navbar-nav > li > a:focus-visible,
.header-nav-desktop .uk-navbar-nav > li > .uk-navbar-item:hover,
.header-nav-desktop .uk-navbar-nav > li > .uk-navbar-item:focus-visible {
  color: #07468d !important;
}

.nav-current {
  color: #07468d;
  cursor: default;
}

.nav-current-dropdown {
  color: #333;
  cursor: default;
  padding: 5px 0;
}

.services-nav-trigger {
  gap: 6px;
  border: 0;
  background: transparent;
  color: #07468d;
  font: inherit;
  cursor: pointer;
}

.services-nav-item.uk-active .services-nav-trigger,
.services-nav-trigger:hover,
.services-nav-trigger:focus-visible {
  color: #07468d;
}

.services-nav-trigger:focus-visible {
  outline: 3px solid rgba(240, 87, 152, 0.42);
  outline-offset: -3px;
}

.services-menu {
  width: 370px;
  padding: 16px;
  border: 1px solid #dce4ec;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 18px 46px rgba(15, 38, 95, 0.16);
}

.services-menu__eyebrow {
  margin: 0 0 8px;
  padding: 0 10px;
  color: #68758a;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.services-menu__list > li + li {
  margin-top: 4px;
}

.services-menu__list > li {
  width: 100%;
}

.services-menu__item {
  display: grid !important;
  grid-template-columns: 42px 1fr;
  gap: 12px;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 64px;
  padding: 10px !important;
  border-radius: 10px;
  color: #243047 !important;
}

.services-menu__item:hover,
.services-menu__item:focus-visible,
.services-menu__list li.uk-active .services-menu__item {
  background: #eef4fb;
  color: #07468d !important;
  text-decoration: none;
}

.services-menu__item:focus-visible {
  outline: 3px solid rgba(240, 87, 152, 0.42);
  outline-offset: 1px;
}

.services-menu__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #e5eef9;
  color: #07468d;
}

.services-menu__item strong,
.services-menu__item small {
  display: block;
}

.services-menu__item strong {
  color: inherit;
  font-size: 15px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.25;
}

.services-menu__item small {
  margin-top: 3px;
  color: #68758a;
  font-size: 12px;
  line-height: 1.35;
}

.mobile-menu-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  min-width: 40px;
  padding: 0 6px;
  color: #07468d !important;
}

.mobile-profile-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  color: #07468d;
}

.mobile-nav-drawer {
  width: min(84vw, 320px);
  padding: 24px 20px;
  background: #ffffff;
  color: #1f2937;
}

.mobile-nav-links li a {
  padding: 12px 0;
  font-size: 16px;
  font-weight: 400;
  color: #07468d;
}

.mobile-nav-links > li > a {
  color: #07468d !important;
}

.mobile-nav-links li.uk-active a {
  color: #07468d !important;
  font-weight: 400;
}

.mobile-services-group {
  margin: 3px 0;
}

.mobile-services-group details,
.mobile-services-group summary,
.mobile-services-group ul {
  margin: 0;
  padding: 0;
}

.mobile-services-group summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  color: #07468d;
  font-size: 16px;
  font-weight: 400;
  list-style: none;
  cursor: pointer;
}

.mobile-services-group summary::-webkit-details-marker {
  display: none;
}

.mobile-services-group summary .uk-icon {
  transition: transform 0.18s ease;
}

.mobile-services-group details[open] summary .uk-icon {
  transform: rotate(180deg);
}

.mobile-services-group--active summary {
  color: #07468d;
}

.mobile-services-group ul {
  margin: 0 0 8px 5px;
  padding: 2px 0 4px 14px;
  border-left: 2px solid #dce7f4;
  list-style: none;
}

.mobile-nav-links .mobile-services-group li a {
  display: block;
  padding: 10px 12px;
  border-radius: 9px;
  color: #243047;
}

.mobile-services-group li + li {
  margin-top: 3px;
}

.mobile-nav-links .mobile-services-group li.uk-active a {
  background: #eef4fb;
  color: #07468d;
}

.mobile-services-group a strong,
.mobile-services-group a small {
  display: block;
}

.mobile-services-group a strong {
  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;
}

.mobile-services-group a small {
  margin-top: 2px;
  color: #68758a;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
}

@media (max-width: 767px) {
  .uk-navbar-container {
    padding-left: 8px;
    padding-right: 8px;
  }

  .uk-logo {
    padding-left: 0;
    padding-right: 0;
  }

  .uk-logo img {
    width: 84px;
  }

  .pro-badge {
    margin-left: 6px !important;
    font-size: 10px;
  }

  .header-nav-desktop {
    display: none;
  }

  .header-nav-mobile {
    display: flex;
  }
}

@media (prefers-reduced-motion: reduce) {
  .mobile-services-group summary .uk-icon {
    transition: none;
  }
}
</style>
